module.exports = __webpack_public_path__ + "img/20.problem_mirro.b19bf027.svg";